module.exports = __webpack_public_path__ + "remedy.png";